import React from "react";
import { CalendarCog, Users, Network, Swords, QrCode, MonitorPlay, WifiOff, Languages, ShieldCheck, Trophy } from "lucide-react";
import { useM } from "@/marketing/useM";
import { Reveal, Eyebrow, BrowserFrame } from "@/marketing/ui";
import { CtaBanner } from "@/marketing/home/Pricing";

const ICONS = [CalendarCog, Users, Network, Swords, QrCode, MonitorPlay, WifiOff, Languages, ShieldCheck, Trophy];
const SHOTS = { 3: "pools", 5: "control" };

const FeatureCard = ({ n, m }) => {
  const Icon = ICONS[n - 1];
  const shot = SHOTS[n];
  return (
    <Reveal delay={(n % 3) * 0.08} className={`group relative overflow-hidden rounded-2xl border border-white/10 bg-mk-navy p-8 transition-colors duration-300 hover:border-mk-yellow/40 ${shot ? "md:col-span-2" : ""}`}>
      <div data-testid={`feature-card-${n}`} className={shot ? "grid gap-8 lg:grid-cols-[1fr_1.4fr] lg:items-center" : ""}>
        <div>
          <div className="flex items-center justify-between">
            <Icon size={24} className="text-mk-yellow" />
            <span className="font-mono-t text-xs text-white/30">{String(n).padStart(2, "0")}</span>
          </div>
          <h3 className="mt-10 font-heading text-2xl font-bold uppercase text-white lg:text-3xl">{m(`feat.${n}.t`)}</h3>
          <p className="mt-3 text-sm leading-relaxed text-mk-muted md:text-base">{m(`feat.${n}.d`)}</p>
        </div>
        {shot && <BrowserFrame src={`/media/shots/${shot}.jpg`} alt={m(`feat.${n}.t`)} className="transition-transform duration-500 group-hover:-translate-y-1" />}
      </div>
    </Reveal>
  );
};

export default function Features() {
  const m = useM();
  return (
    <div data-testid="features-page">
      <section className="relative overflow-hidden pb-20 pt-40 lg:pt-48">
        <Reveal className="relative mx-auto max-w-7xl px-6 lg:px-10">
          <Eyebrow>{m("feat.eyebrow")}</Eyebrow>
          <h1 className="mt-6 max-w-4xl font-heading text-5xl font-black leading-[0.9] text-white sm:text-6xl lg:text-8xl" data-testid="features-title">{m("feat.title")}</h1>
        </Reveal>
      </section>
      <section className="mx-auto grid max-w-7xl gap-5 px-6 pb-28 md:grid-cols-2 lg:grid-cols-3 lg:px-10">
        {ICONS.map((_, i) => <FeatureCard key={i} n={i + 1} m={m} />)}
      </section>
      <CtaBanner />
    </div>
  );
}
